import React from 'react'
import ContactForm from '../../Components/Contact/ContactForm/ContactForm';

const Contact = () => {
  return (
    <div>
      <ContactForm/>
    </div>
  )
}

export default Contact;